export default function Maps(){
    return (
        <>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13294.788594501677!2d73.0749635!3d33.5872117!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df930abbd4f19f%3A0xa9a3e1ff392f9ae4!2sRumi%20House!5e0!3m2!1sen!2s!4v1688492161714!5m2!1sen!2s" 
        style={{
            width:"100%",height:"300px",allowfullscreen:"",
            loading:"lazy",referrerpolicy:"no-referrer-when-downgrade",
            marginTop:'100px'
        }}
        ></iframe>
        </>
    )
}